import {
  CHECK_LOGIN,
  LOGIN_USER_SUCCESSFUL,
  API_ERROR,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  FORCE_LOGOUT,
  CLEAR_ALL_LOGIN_MESSAGES_SUCCESSFUL,
} from "./actionTypes";

const initialState = {
  loginError: "",
  message: null,
  loading: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_LOGIN:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
      };
      break;

    case LOGOUT_USER:
      state = { ...state };
      break;
    case FORCE_LOGOUT:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;

    case API_ERROR:
      console.log("API_ERROR :: ", action.payload.message)
      state = {
        ...state,
        loading: false,
        loginError: action.payload.message
      };
      break;
    case CLEAR_ALL_LOGIN_MESSAGES_SUCCESSFUL:
        state = {
          ...state,
          loginError: null,
          message: null,
          loading: false,
        };
        break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
